import anime from 'animejs/lib/anime.es'

class Animation {
  /**
   * show dialog from top
   * @param {DOM} targets 
   * @param {Number} duration 
   */
  topIn (targets, duration = 800) {
    anime({
      targets,
      top: ['0%', '50%'],
      duration
    })
  }
  /**
   * Toast
   */
  toast (el, fn, duration = 800) {
    anime({
      targets: el,
      scale: [0.6, 1],
      duration,
      complete () {
        if (typeof fn === 'function') fn()
      }
    })
  }
  /**
   * animate kite
   * @param {DOM} targets 
   * @param {Number} duration 
   */
  animateKite (targets, duration = 1200) {
    anime({
      targets,
      rotate: -6,
      duration,
      direction: 'alternate',
      easing: 'easeInOutQuad',
      loop: true
    })
  }
}

export default new Animation()



// WEBPACK FOOTER //
// ./src/utils/animation.js